import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import React from "react";

interface Props {
  value: number
  onChange: (newValue: number) => void
}

const RepetitionsDropdown = (props: Props) => {
  const options = Array.from({ length: window.serverReference.constants.show.maxCopies }).map((_, idx) => ({ value: idx + 1 }));

  return <div className="flex">
    <BaseReactSelectDropdown
      excludeKeys={[]}
      options={options}
      getLabel={num => num.value.toString()}
      getValue={num => num.value}
      value={{ value: props.value }}
      onChange={v => { props.onChange(v.value); }}
      config={{ isSearchable: false }}
    />
  </div>;
};

export default RepetitionsDropdown;